import { get, post } from './uta-services';

export const fetchGraphQLTokens = async () => get('/v2/graphql/tokens');

export const isGraphQLTokenExpired = async (jwtToken) =>
  post('/v2/graphql/is-token-expired', { jwtToken });
